import GET_RING_LOCATIONS from '@amzn/ring-neighbors-api-orchestrator-gql-schema/operations/authenticated/posting/getRingLocations.graphql';
import { useCallback } from 'react';
import { useIsNpssUser } from 'src/auth';
import { useAlertAreaState } from 'src/context';
import { useQueryWithBoundary } from 'src/hooks';

export const normalizeLocation = (location: any) => ({
  id: location.id,
  name: location.details.name,
});

interface RingLocationDetails {
  name: string;
}

interface RingLocation {
  id: string;
  details: RingLocationDetails;
}

interface QueryData {
  ringLocations?: Array<RingLocation>;
}

export const useGetRingLocations = (options: any = {}) => {
  const isNpssUser = useIsNpssUser();
  const { selectedAlertArea } = useAlertAreaState();

  const { data, ...rest } = useQueryWithBoundary(GET_RING_LOCATIONS, {
    ...options,
    skip: isNpssUser || !selectedAlertArea,
    onCompleted: (rawData: QueryData) =>
      options?.onCompleted(enhancedData(rawData)),
  });

  const enhancedData = useCallback(
    (data: QueryData) =>
      data?.ringLocations
        ?.filter(({ id }: RingLocation) =>
          selectedAlertArea!.details.ring_location_ids.includes(id),
        )
        .map(normalizeLocation),
    [selectedAlertArea],
  );

  return {
    ...rest,
    data: enhancedData(data) || [],
  };
};
